import React from "react";
import "./Privacy.css";
import Layout from "../../HOC/Layput/Layout";

const Privacy = () => {
  document.title = "VK Global Publications | Privacy"

  return (
    <div>
      <h4 className="privacyHeading">Terms & Conditions User Agreement </h4>
      <div className="privacyContent">
        <i className="icon dripicons-chevron-right privacyIcon"></i>
        <span className="sub-heading">REGISTRATION DATA</span>
        <p>
          REGISTRATION DATA These Terms of Use govern your use of the website,
          content and community services offered through http://www.xamidea.in
          ("Site") any mobile or internet connected device or otherwise (the
          "the Service"). These terms of use (Terms) constitute a legally
          binding agreement between you and the Company regarding your use of
          the web site i.e http://www.xamidea.in (the Site) and any services
          offered by the company including but not limited to delivery of
          content via the Site, any mobile or internet connected device or
          otherwise (the "the Service"). By accessing the Site or Service and/or
          by clicking "I agree", you agree to be bound by these Terms. You
          hereby represent and warrant to the Company that you are at least
          eighteen (18) years of age or above and are capable of entering,
          performing and adhering to these Terms and that you agree to be bound
          by the following terms and conditions. While individuals under the age
          of 18 may utilize the Service of the site, they shall do so only with
          the involvement & guidance of their parents and / or legal guardians,
          under such Parent /Legal guardian's registered account. You agree to
          register prior to uploading any content and / or comment and any other
          use or services of this site and provide your details including but
          not limited to complete name, age, email address, residential address,
          and contact number. Definition of "User" or "You": means any person
          who access or avail this site of the Company for the purpose of
          hosting, publishing, sharing, transacting, displaying or uploading
          information or views and includes other persons jointly participating
          in using the site of the Company. VK Global Publications Pvt. Limited
          ("The Company") may add to or change or update these Terms of Use,
          from time to time entirely at its own discretion. You are responsible
          for checking these Terms of Use periodically to remain in compliance
          with these terms. Your use of a Site after any amendment to the Terms
          of Use shall constitute your acceptance of these terms and you also
          agree to be bound by any such changes/revisions.
        </p>
        <i className="icon dripicons-chevron-right privacyIcon"></i>

        <span className="sub-heading">CHANGES</span>
        <p>
          The Company reserves the right to suspend / cancel, or discontinue any
          or all channels, products or service at any time without notice , make
          modifications and alterations in any or all of the content, products
          and services contained on the site without prior notice. Such changes
          will be posted to http://www.xamidea.in for your reference and
          convenience so as to enable you to understand your responsibility as a
          user.
        </p>

        <i className="icon dripicons-chevron-right privacyIcon"></i>

        <span className="sub-heading">CHARGES</span>
        <p>
          The Company reserves the right to charge subscription and / or
          membership fees from a user, by giving reasonable prior notice, in
          respect of any product, service or any other aspect of this Site.
        </p>

        <i className="icon dripicons-chevron-right privacyIcon"></i>

        <span className="sub-heading">COPYRIGHT AND TRADEMARKS</span>
        <p>
          Unless otherwise stated, copyright and all intellectual property
          rights in all material presented on the site (including but not
          limited to text, audio, video or graphical images), trademarks and
          logos appearing on this site are the property of VK Global
          Publications Private Limited, its affiliates and associates and are
          protected under applicable Indian laws. You agree not to use any
          framing techniques to enclose any trademark or logo or other
          proprietary information of The Company; or remove, conceal or
          obliterate any copyright or other proprietary notice or any
          credit-line or date-line on other mark or source identifier included
          on the Site / Service, including without limitation, the size, color,
          location or style of all proprietary marks. Any infringement shall be
          vigorously defended and pursued to the fullest extent permitted by
          law.
        </p>

        <i className="icon dripicons-chevron-right privacyIcon"></i>

        <span className="sub-heading">LIMITED PERMISSION TO COPY</span>
        <p>
          The Company grants you permission to only access and make personal use
          of the Site and You agree not to, directly or indirectly download or
          modify / alter / change / amend / vary / transform / revise /
          translate / copy / publish / distribute or otherwise disseminate any
          content on the Site / Service, or any portion of it; or delete or fail
          to display any promotional taglines included in the Site / Service
          either directly or indirectly, except with the express consent of the
          company. However, you may print or download extracts from these pages
          for your personal / individual, non-commercial use only. You must not
          retain any copies of these pages saved to disk or to any other storage
          medium except for the purposes of using the same for subsequent
          viewing purposes or to print extracts for personal / individual use.
          The Company forbids you from any attempts to resell or put to
          commercial use any part of the Site; any collection and use of any
          product listings, descriptions, or prices; any derivative use of the
          Site or its contents; any downloading or copying of account
          information for the benefit of any other merchant; any renting,
          leasing, or otherwise transferring rights to the Site / Service;
          displaying the name, logo, trademark or other identifier of another
          person in such a manner as to give the viewer the impression that such
          other person is a publisher or distributor of the Service on the Site,
          or any data gathering or extraction tools; or any use of meta tags.
          You may not (whether directly or through the use of any software
          program) create a database in electronic or structured manual form by
          regularly or systematically downloading and storing all or any part of
          the pages from this site. No part of the Site may be reproduced or
          transmitted to or stored in any other web site, nor may any of its
          pages or part thereof be disseminated in any electronic or
          non-electronic form, nor included in any public or private electronic
          retrieval system or service without prior written permission. Requests
          to republish xamidea.in material for distribution should be addressed
          to VK Global Publications Private Limited by E-Mail on
          mail@vkpublications.com
        </p>

        <i className="icon dripicons-chevron-right privacyIcon"></i>

        <span className="sub-heading">
          INDIVIDUAL REGISTRATION, ACCESS AND EXCHANGE OF INFORMATION
        </span>
        <p>
          For certain services such as shopping, registration by the visitor is
          required. To register for these services you have to open an account
          by completing the registration process (i.e. by providing us with
          current, complete and accurate information as prompted by the
          applicable registration form). You also will choose a password and a
          user name. You are entirely responsible for maintaining the
          confidentiality of your password and account. By registering, you
          agree to the following terms in addition to any other specific terms
          which shall be posted at an appropriate location of the Site. Each
          registration is for a single individual user only. To access these
          services, you will be asked to enter your individual User Name and
          Password, as chosen by you during your registration.
          <br />
          If The Company reasonably believes that an account and Password is
          being used / misused in any manner, The Company shall reserve the
          right to cancel access rights immediately without notice, and block
          access to all users from that IP address.
          <br />
          Furthermore, you are entirely responsible for any and all activities
          that occur under your account. You agree to notify The Company
          immediately of any unauthorized use of your account or any other
          breach of security. The Company will not be liable for any loss that
          you may incur as a result of someone else using your password or
          account. However, you could be held liable for losses incurred by The
          Company or another party due to someone else using your account or
          password.
          <br />
          Grievance Redressal
          <br />
          "Redressal Mechanism : Any complaints or concerns with regards to
          content and or comment or breach of these terms shall be taken up with
          the designated Grievance Officer for respective website as mentioned
          below via in writing or through email at their respective email id,
          signed with the electronic signature to the respective Grievance
          Officer" Please note that the email addresses given below are meant
          for receiving concerns and queries regarding the corresponding
          websites
          <br />
          <br />
         <b> VK Global Publications Private Limited </b>
         <br />
         4323/3, Ansari Road Daryaganj
          <br />
          New Delhi 110002, India
          <br />
          <b>Ph:</b> 011-23250105 
          <br />
          <b>Email: </b> mail@vkpublications.com.
        </p>
      </div>
    </div>
  );
};

export default Layout(Privacy, " Privacy ");
